import { useAppSelector } from '@app/hooks';
import { selectContentCustomization } from '@modules/app';
import { getFeatureContent } from './helpers';

export function useFeatureContent(contentKey: string) {
    const content = useAppSelector(selectContentCustomization);

    return getFeatureContent(content, contentKey);
}
